export default __webpack_public_path__ + "static/media/sip-picturemark-l.67f7f16d.svg";